<template>
    <div>
        <Transition v-if="isLoading"
                    name="spinner">
            <div id="cover-spin"></div>
        </Transition>

        <ConfirmDialog header="Confirm operation"
                       question="Do you want to get workers data from SAP system?"
                       v-model="isConfirmationGetSapWorkersOpen"
                       :operation="actionGetSapWorkersButton"
                       :parameter="propertiesFromForm" />

        <ConfirmDialog header="Confirm operation"
                       question="Do you want to create user accounts for selected workers?"
                       v-model="isConfirmationAddToUsersOpen"
                       :operation="actionAddToUsersButton"
                       :parameter="recordSelectedToPass" />

        <ConfirmDialog header="Confirm operation"
                       question="Do you want to approve assesses sheets?"
                       v-model="isConfirmationApproveSheetsOpen"
                       :operation="approveSheets"
                       :parameter="approveSheetsParameter" />

        <ConfirmDialog header="Confirm operation"
                       question="Do you want to pass to approve assesses sheets?"
                       v-model="isConfirmationPassToApproveSheetsOpen"
                       :operation="passToApproveSheets"
                       :parameter="passToApproveSheetsParameter" />

        <ConfirmDialog header="Confirm operation"
                       question="Do you want to pass to accept assesses sheets?"
                       v-model="isConfirmationPassToAcceptSheetsOpen"
                       :operation="passToAcceptSheets"
                       :parameter="passToAcceptSheetsParameter" />


        <Dialog modal
                :visible="isGenerateSheetsModalOpen"
                v-model:visible="isGenerateSheetsModalOpen"
                :header="__('Generate sheets')"
                :style="{ width: '500px' }">
            <p style="padding-bottom:15px;font-size:16px; font-weight:bold;color:cadetblue">{{ __('Sheets will be generated for selected premium group') }}</p>

            <GenerateSheetsForm :formProps="generateSheetsFormProps"
                                v-model:isGenerateSheetsModalOpen="isGenerateSheetsModalOpen">
            </GenerateSheetsForm>
        </Dialog>

        <Dialog modal
                :visible="whoAmICountingOpen"
                v-model:visible="whoAmICountingOpen"
                :header="__('Who I am counting?')"
                :style="{ width: '600px' }">
            <p style="font-size:16px; font-weight:bold;color:cadetblue">{{ __('Information about counting way of workers and sheets') }}</p>
            <div style="padding-bottom:15px;font-size:12px; font-weight:normal;color:black;font-style:italic;">{{ __('strikethrough indicates an approved sheet from a given period') }}</div>
            <div style="padding: 5px 0">
                <div v-html="interpretedSheetAndWorkersCounting"
                     style="height:300px;overflow-y: auto;">
                </div>
            </div>
            <Button severity="secondary"
                    style="margin:10px 8px"
                    @click="whoAmICountingOpen = false">
                <i class="fa-solid fa-ban"
                   style="margin-right:5px;font-size:18px"></i>
                {{ __('Close') }}
            </Button>

        </Dialog>

        <v-view :tableData="tableData"
                :tableProps="tableProps"
                :modalProps="modalProps"
                :columns="columns"
                :routes="routes"
                :initialSort="initialSort"
                :renderColumnValue="renderColumnValue"
                :renderColumnAction="renderColumnAction"
                :rowButtonAction="rowButtonAction"
                :selectCheckboxConditions="selectCheckboxConditions"
                :buttonsVisibility="buttonsVisibility">

            <template #buttons="formProps">
                <div class="flex flex-column md:flex-row flex-grow-1 align-items-center mt-3 pt-2 gap-1 border-top-1 border-gray-200">

                    <div>
                        <Button @click.stop="whoAmICounting()"
                                v-tooltip.top="__('Who I am counting?')"
                                severity="primary">
                            <i class="fa-solid fa-question"
                               style="margin-right:5px;font-size:18px"></i>
                        </Button>
                    </div>
                    <div v-if="canGenerateSheets">
                        <Button @click.stop="openGenerateSheetsWindow(formProps)"
                                severity="primary">
                            <i class="fa-solid fa-sheet-plastic"
                               style="margin-right:5px;font-size:18px"></i>
                            {{ __('Generate sheets') }}
                        </Button>
                    </div>

                    <div v-if="canPassToApproveSheets">
                        <Button @click.stop="openConfirmationPassToApproveSheetsWindow(formProps)"
                                severity="primary">
                            <i class="fa-solid fa-pen-fancy"
                               style="margin-right:5px;font-size:18px"></i>
                            {{ __('Pass sheets to approve') }}
                        </Button>
                    </div>

                    <div v-if="canPassToAcceptSheets">
                        <Button @click.stop="openConfirmationPassToAcceptSheetsWindow(formProps)"
                                severity="primary">
                            <i class="fa-solid fa-check-to-slot"
                               style="margin-right:5px;font-size:18px"></i>
                            {{ __('Pass sheets to accept') }}
                        </Button>
                    </div>
                    <div v-if="canFilterByActiveWorkers"
                         class="flex flex-column gap-1">
                        <div class="text-sm text-color-secondary ml-2 -mb-1">{{ __('Important') }}:</div>
                        <FormInputToggleButton fieldName="show_active_workers"
                                               label=""
                                               style="display:flex;width:auto;justify-content:space-between;align-items:flex-start;"
                                               v-tooltip.top="__('Show only working and premium subjected workers')"
                                               :change="(e) => setWorkersViewState(e, formProps)"
                                               v-model:field="show_active_workers" />
                    </div>

                    <div class="flex flex-column gap-1">
                        <div class="text-sm text-color-secondary ml-2 -mb-1">{{ __('Workers on day') }}:</div>
                        <FormCalendar fieldName="workers_on_day"
                                      label=""
                                      outerStyle=""
                                      labelStyle=""
                                      :formProps="formProps"
                                      :minDate="new Date(minDate)"
                                      :maxDate="new Date()"
                                      :manualInput="false"
                                      :dateSelect="(e) => workersOnDayChanged(e, formProps)"
                                      :clearClick="(e) => workersOnDayCleared(e, formProps)"
                                      :onMounted="() => workersOnDayInit(formProps)"
                                      v-model:field="workers_on_day" />
                    </div>
                    <div v-if="canFilterByManager"
                         class="flex flex-column gap-1">
                        <div class="text-sm text-color-secondary ml-2 -mb-1">{{ __('Manager') }}:</div>
                        <FormDropdown fieldName="manager_id_to_filter_workers"
                                      label=""
                                      showClear
                                      style="min-width: 200px;"
                                      :filtering="true"
                                      :isFormDisabled="false"
                                      :change="(e) => filterWorkersByManager(e, formProps)"
                                      :filter="(event) => onFilter(event, 'workers')"
                                      :options="select?.managers"
                                      v-model:field="localManagerIdToFilterWorkers" />
                    </div>

                    <div class="flex flex-column gap-1">
                        <div class="text-sm text-color-secondary ml-2 -mb-1">{{ __('Show only') }}:</div>
                        <FormDropdown fieldName="show_only_status"
                                      label=""
                                      showClear
                                      style="min-width: 200px;"
                                      :change="(e) => filterWorkersByShowOnlyStatus(e, formProps)"
                                      :filtering="false"
                                      :isFormDisabled="false"
                                      :options="showOnlyStatusOptions"
                                      v-model:field="showOnlyStatus" />
                    </div>
                </div>
            </template>

            <template #others="formProps">
                <div v-if="canApproveSheets">
                    <Button @click.stop="openConfirmationApproveSheetsWindow(formProps)"
                            :class="{ blink: isBlinking }"
                            style="margin:0 7px 0 30px;white-space:nowrap;display:block;"
                            severity="warning">
                        <i class="fa-regular fa-thumbs-up"
                           style="margin-right:5px;font-size:18px;"></i>
                        {{ __('Approve sheets') }}
                    </Button>
                </div>

            </template>

            <template #buttons-in-footer="formProps">
                <div v-if="canGetSapWorkers">
                    <Button @click.stop="openConfirmationGetSapWorkersWindow(formProps)"
                            style="background-color:#6366F1;color:#fff;margin:0 7px 0 0px;white-space:nowrap"
                            severity="primary">
                        <i class="fa-solid fa-users-viewfinder"
                           style="margin-right:5px;font-size:18px"></i>
                        {{ __('Get SAP workers') }}
                    </Button>
                </div>
                <div v-if="canCreateUsers">
                    <Button @click.stop="openConfirmationAddToUserWindow(formProps)"
                            style="background-color:#6366F1;color:#fff;margin:0 7px 0 25px;white-space:nowrap"
                            severity="primary">
                        <i class="fa-solid fa-users-gear"
                           style="margin-right:5px;font-size:18px"></i>
                        {{ __('Create users') }}
                    </Button>
                </div>
            </template>

            <template #informations>
                <div class='flex gap-2 flex-wrap:nowrap view-header-information'
                     style="margin-left:30px;margin-top:5px">
                    <span v-if="averageAssessments?.averageMonth > 0"
                          class="flex gap-2">
                        <div style="color:green;">{{ __('Average assessment per month') }}:</div>
                        <div style="color:red;font-weight:bold;">{{ averageAssessments?.averageMonth }}</div>
                    </span>
                    <span v-if="averageAssessments?.averageQuarter > 0"
                          class="flex gap-2">
                        <div style="margin-left:30px;color:green">{{ __('Average assessment per quarter') }}:</div>
                        <div style="color:red;font-weight:bold;">{{ averageAssessments?.averageQuarter }}</div>
                    </span>
                </div>
            </template>

            <template #crud="formProps">
                <WorkerForm :formProps="formProps"> </WorkerForm>
            </template>
            <template #search="searchProps">
                <WorkerSearch :searchProps="searchProps"> </WorkerSearch>
            </template>
        </v-view>
    </div>
</template>

<script setup>
import { ref, watch, onBeforeMount, onMounted } from "vue";
import { useForm, usePage } from '@inertiajs/vue3'
import Button from 'primevue/button';
import WorkerForm from "./WorkerForm.vue";
import WorkerSearch from "./WorkerSearch.vue";
import ConfirmDialog from '@pages/Crud/ConfirmDialog.vue'
import Dialog from 'primevue/dialog';
import FormCalendar from '@crud/FormCalendar.vue'
import FormInputToggleButton from '@crud/FormInputToggleButton.vue'
import FormDropdown from '@crud/FormDropdown.vue'
import GenerateSheetsForm from "./GenerateSheetsForm.vue";
import { __, screenMessage, convertDate, getFromRoute, getStoreValue, getServerValue, setStoreValue, getTimeouts } from "@pages/Helper/utils.js";
import { rowButtonAction, prepareSelect, onFilterService } from "@pages/Helper/crud_utils.js";
import { warningIcon, prematureIcon } from '@helper/constants.js'
//import { getSessionPeriod } from "@pages/Helper/custom.js";

const props = defineProps({
    data: Object,
    tableData: Object,
    tableProps: Object,
    modalProps: Object,
    columns: Object,
    routes: Object,
    tooltipColumns: Object,
    initialSort: Object,
    buttonsVisibility: Object,
    versionDate: String,
    minDate: String,
    canCreateUsers: Boolean,
    canGenerateSheets: Boolean,
    canApproveSheets: Boolean,
    canPassToApproveSheets: Boolean,
    canPassToAcceptSheets: Boolean,
    canGetSapWorkers: Boolean,
    canFilterByManager: Boolean,
    canFilterByActiveWorkers: Boolean,
    averageAssessments: Object,
    summarySheetsAndWorkers: String,
    showActiveWorkers: Boolean,
    managerIdToFilterWorkers: Number,
    showOnlyStatus: String,
});

const isLoading = ref(false)
const isConfirmationGetSapWorkersOpen = ref(false)
const isConfirmationAddToUsersOpen = ref(false)
const isConfirmationApproveSheetsOpen = ref(false)
const isConfirmationPassToApproveSheetsOpen = ref(false)
const isConfirmationPassToAcceptSheetsOpen = ref(false)

const recordSelectedToPass = ref(null)
const approveSheetsParameter = ref(null)
const passToApproveSheetsParameter = ref(null)
const passToAcceptSheetsParameter = ref(null)
const propertiesFromForm = ref(null)

const isGenerateSheetsModalOpen = ref(false)
const generateSheetsFormProps = ref({})
const workers_on_day = ref(props.versionDate)
const show_active_workers = ref(props.showActiveWorkers)

const whoAmICountingOpen = ref(false)
const interpretedSheetAndWorkersCounting = ref(null)

const premiumPeriod = ref(null)
const page = usePage()
const images = import.meta.globEager('/resources/images/**')

const options = ['managers']
const select = ref(null)
const localManagerIdToFilterWorkers = ref(props.managerIdToFilterWorkers)
const showOnlyStatus = ref(props.showOnlyStatus);

const isBlinking = ref(false);
const showOnlyStatusOptions = [
    { label: __('All'), value: null },
    { label: __('Only approved'), value: 'A' },
    { label: __('Only not approved'), value: 'N' },
];

//------------------------------------------------------------------------------

setStoreValue('currentDate', page.props.currentDate)

//------------------------------------------------------------------------------

watch(() => props.showActiveWorkers, (newValue) => {
    show_active_workers.value = newValue;
});

//------------------------------------------------------------------------------

watch(() => props.managerIdToFilterWorkers, (newValue) => {
    localManagerIdToFilterWorkers.value = newValue;
});

//------------------------------------------------------------------------------


watch(() => props.showOnlyStatus, (newValue) => {
    showOnlyStatus.value = newValue;
});

//------------------------------------------------------------------------------

onBeforeMount(async () => {
    select.value = await prepareSelect(options)
})

//------------------------------------------------------------------------------

onMounted(() => {
    startBlinking();
});

//------------------------------------------------------------------------------

const renderColumnValue = (field, value, data) => {
    if (data.premature && field === 'last_name') {
        const key = `/resources/images/${prematureIcon}`
        const img = images[key]?.default

        return "<span style='display:flex;align-items:center;' title='" + __('Worker is marked as premature, please assess him earlier than others') + "'>" + value + ' ' + "<img style='padding-left:10px;' src='" + img + "' /></span>";
    }

    switch (field) {
        case 'last_name':
            //if ((data.is_working && data.dismissal_date) || (data.is_premium && (data.premium_from_date || data.premium_to_date))) {
            if (data.is_about_to_change) {
                const key = `/resources/images/${warningIcon}`
                const img = images[key]?.default
                return "<span style='display:flex;align-items:center;' title='" + __('Worker will soon be dismissed or no longer be subject of premium system') + "'>" + value + ' ' + "<img style='padding-left:10px;' src='" + img + "' /></span>";
            } else {
                return data.is_master_subordinate ? '<span style="color:blue">' + value + '</span>' : value;
            }
        case "is_premium":
            return value == 1 ? '<span class="flex justify-content-center"><i class="fa-solid fa-coins" style="font-size:20px;color:royalblue;"></i></span>' : "";
        case "is_working":
            //return value == 1 ? '<span class="flex justify-content-center"><i class="fa-solid fa-person-digging" style="font-size:20px;color:maroon;"></i></span>' : "";
            return value == 1 ? __('Yes') : __('No');
        case "last_or_selected_sheet_status":
            return value;
        default:
            return data.is_master_subordinate ? '<span style="color:blue">' + value + '</span>' : value;
    }
};

//------------------------------------------------------------------------------

const renderColumnAction = (item, rowData, column) => {
    let newItem = {}

    if (!rowData.is_subject_to_premium_system) {
        newItem.tooltip = __('Not subject to premium system')
        newItem.prohibited = true
        newItem.name = '<i class="fa-solid fa-ban" style="color:black;"></i>'
    } else {
        newItem.prohibited = false
        newItem.tootip = item.tooltip
        newItem.name = item.name
    }

    return { ...newItem }
}

//------------------------------------------------------------------------------

const workersOnDayChanged = async (value, formProps) => {
    if (value) {
        const workersOnDayDate = convertDate(value)
        await formProps.getLazyData({ page: 1, versionDate: workersOnDayDate })
    }
}

//------------------------------------------------------------------------------

const workersOnDayInit = async (formProps) => {
    //await nextTick()
    const value = await getServerValue('versionDate')
    if (value) {
        const workersOnDayDate = convertDate(value.versionDate)
        workers_on_day.value = workersOnDayDate
    }
}

//------------------------------------------------------------------------------

const workersOnDayCleared = async (value, formProps) => {
    await formProps.getLazyData({ page: 1, versionDate: null });
}

//------------------------------------------------------------------------------

const actionGetSapWorkersButton = async (propertiesFromForm) => {
    isLoading.value = true
    const response = await getFromRoute('worker-get-from-sap', {}, 'get')
    isLoading.value = false

    const timeouts = getTimeouts()
    if (response.status == 'success') {
        screenMessage({ message: response.message, title: "Information", type: "info", position: "center", timeout: timeouts.info });
    } else {
        screenMessage({ message: response.message, title: "Information", type: "error", position: "center", timeout: timeouts.error });
    }

    propertiesFromForm.getLazyData()
}

//------------------------------------------------------------------------------

const actionAddToUsersButton = (formProps) => {
    const records = formProps.selectedRows;
    let ids = [];
    for (let record of records) {
        ids.push(record.id);
    }

    const timeouts = getTimeouts()
    const formData = { selectedRows: ids }
    useForm(formData).post(route('user-addfromworkers'), {
        preserveState: true,
        preserveScroll: true,
        forceFormData: true,
        onError: (errors) => {
            console.error(errors)
        },
        onSuccess: () => {
            const message = {
                message: "Selected workers was added to users database successfully",
                title: "Information",
                type: "info",
                position: "center",
                timeout: timeouts.info,
            };
            screenMessage(message);
        },
        onFinish: () => {
            formProps.clearSelection()
            formProps.getLazyData()
        }
    })
}

//------------------------------------------------------------------------------

const openConfirmationGetSapWorkersWindow = (formProps) => {
    isConfirmationGetSapWorkersOpen.value = true
    propertiesFromForm.value = formProps
}

//------------------------------------------------------------------------------

const openConfirmationAddToUserWindow = (formProps) => {
    if (!Array.isArray(formProps.selectedRows) || formProps.selectedRows.length === 0) {
        const timeouts = getTimeouts()
        const message = {
            message: "No worker has been selected",
            title: "Worker selection error",
            type: "error",
            position: "center",
            timeout: timeouts.error,
        };
        screenMessage(message);
        return false;
    }

    recordSelectedToPass.value = formProps
    isConfirmationAddToUsersOpen.value = true
}

//------------------------------------------------------------------------------

const selectCheckboxConditions = (data) => {
    data = data.filter((elem) => !(elem.is_master && elem.is_passed_by_master))
    return data
}

//------------------------------------------------------------------------------

const openGenerateSheetsWindow = (formProps) => {
    generateSheetsFormProps.value = formProps
    isGenerateSheetsModalOpen.value = true
}

//------------------------------------------------------------------------------

const openConfirmationApproveSheetsWindow = (formProps) => {
    approveSheetsParameter.value = formProps
    getPremiumPeriod()
    premiumPeriod.value ? isConfirmationApproveSheetsOpen.value = true : noPremiumPeriodInfo()
}

//------------------------------------------------------------------------------

const openConfirmationPassToApproveSheetsWindow = (formProps) => {
    passToApproveSheetsParameter.value = formProps
    getPremiumPeriod()
    premiumPeriod.value ? isConfirmationPassToApproveSheetsOpen.value = true : noPremiumPeriodInfo()
}

//------------------------------------------------------------------------------

const openConfirmationPassToAcceptSheetsWindow = (formProps) => {
    passToAcceptSheetsParameter.value = formProps
    getPremiumPeriod()
    premiumPeriod.value ? isConfirmationPassToAcceptSheetsOpen.value = true : noPremiumPeriodInfo()
}

//------------------------------------------------------------------------------

const approveSheets = async (formProps) => {
    const response = await getFromRoute('sheet-approve', { premiumPeriod: premiumPeriod.value }, 'post')
    formProps.getLazyData()

    const timeouts = getTimeouts()
    if (response.status == 'success') {
        screenMessage({ message: response.message, title: "Information", type: "info", position: "center", timeout: timeouts.info });
    } else {
        screenMessage({ message: response.message, title: "Information", type: "error", position: "center", timeout: timeouts.error });
    }
}

//------------------------------------------------------------------------------

const passToApproveSheets = async (formProps) => {
    const response = await getFromRoute('sheet-pass-approve', { premiumPeriod: premiumPeriod.value }, 'post')
    formProps.getLazyData()

    const timeouts = getTimeouts()
    if (response.status == 'success') {
        screenMessage({ message: response.message, title: "Information", type: "info", position: "center", timeout: timeouts.info });
    } else {
        screenMessage({ message: response.message, title: "Information", type: "error", position: "center", timeout: timeouts.error });
    }
}

//------------------------------------------------------------------------------

const passToAcceptSheets = async (formProps) => {
    const records = formProps.selectedRows ?? [];
    let ids = [];
    for (let record of records) {
        ids.push(record.id);
    }

    const response = await getFromRoute('sheet-pass-accept', { premiumPeriod: premiumPeriod.value, selectedRows: ids }, 'post')
    formProps.clearSelection()
    formProps.getLazyData()

    const timeouts = getTimeouts()
    if (response.status == 'success') {
        screenMessage({ message: response.message, title: "Information", type: "info", position: "center", timeout: timeouts.info });
    } else {
        screenMessage({ message: response.message, title: "Information", type: "error", position: "center", timeout: timeouts.error });
    }
}

//------------------------------------------------------------------------------

const getPremiumPeriod = async () => {
    premiumPeriod.value = getStoreValue('premiumPeriod')
}

//------------------------------------------------------------------------------

const noPremiumPeriodInfo = () => {
    const timeouts = getTimeouts()
    const message = {
        message: "No premium period is selected",
        title: "Premium period error",
        type: "error",
        position: "center",
        timeout: timeouts.error,
    };
    screenMessage(message);
}

//------------------------------------------------------------------------------

const onFilter = async (event, option) => {
    await onFilterService(event, option, select, isLoading);
}

// -----------------------------------------------------

const whoAmICounting = () => {
    interpretedSheetAndWorkersCounting.value = props.summarySheetsAndWorkers
    whoAmICountingOpen.value = true
}

//------------------------------------------------------------------------------

const setWorkersViewState = async (e, formProps) => {
    let state = (e.target.value.toLowerCase() !== 'true')
    await getFromRoute('worker-set-view-state', { state }, 'get')
    show_active_workers.value = state
    formProps.getLazyData({ page: 1 })
}

//------------------------------------------------------------------------------

const filterWorkersByManager = async (e, formProps) => {
    const managerId = e.value
    localManagerIdToFilterWorkers.value = managerId
    await getFromRoute('worker-filter-by-manager', { manager_id: managerId }, 'get')
    formProps.getLazyData({ page: 1 })
}

//------------------------------------------------------------------------------

const filterWorkersByShowOnlyStatus = async (e, formProps) => {
    const status = e.value
    showOnlyStatus.value = status
    await getFromRoute('worker-filter-by-show-only-status', { status }, 'get')
    formProps.getLazyData({ page: 1 })
}

//------------------------------------------------------------------------------

const startBlinking = () => {
    isBlinking.value = true;
    setTimeout(() => {
        isBlinking.value = false;
    }, 10000);
};

//------------------------------------------------------------------------------

</script>

<style lang="scss" scoped>
@keyframes blink {
    0% {
        opacity: 1;
    }

    25% {
        opacity: 0.75;
    }

    50% {
        opacity: 0.1;
    }

    75% {
        opacity: 0.75;
    }


    100% {
        opacity: 1;
    }
}

.blink {
    animation: blink 1s infinite;
}
</style>
